import { typedStyles } from '@/utils/styleUtils';

export const styles = typedStyles({
  modal: {
    width: 'min(80%, 892px)',
    height: '80%',
    overflow: 'hidden',
  },

  form: {
    position: 'relative',
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'auto',
    paddingTop: 9,
  },

  container: {
    width: 'min(100%, 540px)',
    paddingX: 6,
  },

  fields: {
    flex: 1,
    paddingBottom: 6,
  },

  footer: {
    position: 'sticky',
    bottom: 0,
    width: '100%',
    paddingY: 3,
    backgroundColor: 'background.paper',
  },

  controls: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    margin: 'auto',
    gap: 2,
  },

  error: ({ spacing }) => ({
    position: 'sticky',
    top: spacing(-9),
    padding: spacing(3, 0, 2),
    margin: spacing(-9, -6, 1),
    backgroundColor: 'background.paper',
  }),
});
